// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__NpYn5","inputWrap":"CustomTip_inputWrap__3coqq"};